import React from 'react';
import { connect } from 'react-redux';
import MenuList from './MenuList';
import { Link } from 'react-router-dom';

class Sidebar extends React.Component{
    

    async componentDidMount(){
        //await this.props.fetchMenu(this.props.account.idRole);
        window.$("#sidebar").mCustomScrollbar({
            theme: "minimal"
            });
            window.$('#sidebarCollapse').on('click', function () {
            window.$('#sidebar, #content').toggleClass('active');
            window.$('.collapse.in').toggleClass('in');
            window.$('a[aria-expanded=true]').attr('aria-expanded', 'false');
        }); 
    }    

    render(){
        return (
            <nav id="sidebar">
                <div className="sidebar-header">
                    <div className="text-center">
                        <Link to={`/dashboard`}><img alt="Eduprime Logo" style={{width: "90%"}} src="https://s3edubucket.s3-ap-southeast-1.amazonaws.com/images/LogoEduprimePutih.png" /></Link>
                    </div>
                </div>

                <ul className="list-unstyled components">
                    {/* <div className="container">
                        <div className="row" style={{paddingBottom: '20px'}}>                            
                            {<div className="col-md-12 col-lg-12 col-sm-12 text-center" style={{paddingTop: '10px', paddingBottom: '10px'}}>
                                Welcome, <br />{this.props.account.namaUser}
                                
                            </div>}
                        </div>
                    </div> */}
                    <MenuList account={this.props.account} />
                </ul>
            </nav>
        );
    }
}

export default connect(null)(Sidebar);